import React, { useContext } from "react";
import MainContext from "../Context/MainContext/MainContext";
import MUIBox from "@mui/material/Box";

import WidgetDashboardQueue from "./Widget/Dashboard/WidgetDashboardQueue";
import WidgetDashboardPoints from "./Widget/Dashboard/WidgetDashboardPoints";
import WidgetDashboardAccounts from "./Widget/Dashboard/WidgetDashboardAccounts";
import WidgetDashboardOOB from "./Widget/Dashboard/WidgetDashboardOOB";
import WidgetDashboardMultiQueue from "./Widget/Dashboard/WidgetDashboardMultiQueue";
import WidgetDashboardPresidentsClub from "./Widget/Dashboard/WidgetDashboardPresidentsClub";
import WidgetDashboardActivities from "./Widget/Dashboard/WidgetDashboardActivities";
import WidgetDashboardInboundFiles from "./Widget/Dashboard/WidgetDashboardInboundFiles";
import WidgetDashboardUserProduction from "./Widget/Dashboard/WidgetDashboardUserProduction";
import DashboardWidget from "../Utility/Crud/DashboardWidget";


/**
 * Maps configured dashboard widget component term identifiers to dashboard widget components.
 */
const dashboardWidgetComponentMap = {
    219: WidgetDashboardQueue,
    226: WidgetDashboardOOB,
    280: WidgetDashboardMultiQueue,
    224: WidgetDashboardPoints,
    225: WidgetDashboardAccounts,
    227: WidgetDashboardPresidentsClub,
    228: WidgetDashboardActivities,
    279: WidgetDashboardInboundFiles,
    293: WidgetDashboardUserProduction,
};

/**
 * Renders the queue dashboard metric widgets for the current queue.
 *
 * @param {object} props
 * @param {array} props.dashboardWidgets Dashboard widget configuration objects.
 * @param {object | null} props.activeWidget Currently active widget record.
 * @param {function} [props.onActiveWidgetChange] Called with the dashboard widget record when a widget is activated.
 * @param {function} [props.updateActiveWidgetConfiguration] Updates the active widget configuration.
 * @returns {React.ReactElement | null}
 */
export default function WidgetDashboardRow(props) {
    const mainContext = useContext(MainContext);
    const dashboardWidgets = props.dashboardWidgets || [];

    if (dashboardWidgets.length === 0) {
        return null;
    }
 
    return (
        <MUIBox
            sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                marginBottom: 2,
                alignItems: "stretch",
            }}
        >
            {DashboardWidget.sort(dashboardWidgets).map((dashboardWidget, index) => {
                const widgetComponentTermId = mainContext.widgetsIndexed[dashboardWidget.widgetId].widgetComponentTermId;
 
                const DashboardWidgetComponent =
                    dashboardWidgetComponentMap[
                        widgetComponentTermId
                    ];

                if (!DashboardWidgetComponent) {
                    return null;
                }

                return (
                    <DashboardWidgetComponent
                        key={index}
                        widgetId={dashboardWidget.id}
                        dashboardWidget={dashboardWidget}
                        isActive={props.activeWidget?.id === dashboardWidget.id}
                        onActiveWidgetChange={() => props.onActiveWidgetChange?.(dashboardWidget)}
                        updateActiveWidgetConfiguration={props.updateActiveWidgetConfiguration}
                    />
                );
            })}
        </MUIBox>
    );
}
